import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import {
  getTourSaleInput,
  getTourSalesInput,
  TourSaleLiteModel,
  TourSalesModel,
} from './model';

export function useGetTourSales(
  input?: getTourSalesInput,
  options?: UseQueryOptions<ExtendedApiResult<TourSaleLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<TourSaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getTourSales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'tour-sales',
          params: input?.params,
        }),
      options,
    ),
    TourSaleLiteModel,
  );
}

export function useGetTourSale(
  input?: getTourSaleInput,
  options?: UseQueryOptions<ExtendedApiResult<TourSalesModel>, ApiError>,
): UseQueryResult<ExtendedApiResult<TourSalesModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getTourSale', input?.id],
      () => QueryFetchFunction({ url: `tour-sales/${input?.id}` }),
      options,
    ),
    TourSalesModel,
  );
}

export function getTourSalesKey(input?: getTourSalesInput) {
  return ['getTourSales', input?.params];
}

export function getTourSaleKey(input?: getTourSaleInput) {
  return ['getTourSale', input?.id];
}
